import { MenuItem, TextField } from '@common/material'
import { Box, Flex } from '@fundamentals'
import { AdvancedFilterPopover } from './AdvancedFilterPopover'
import {
  advancedDueDateFilterOptionOperators,
  AdvancedDueDateFilterValue,
  AdvancedFilterOptionOperators,
} from '@core/providers/filters'
import { localizedStrings } from '@core/strings'
import { useEffect } from 'react'

type AdvancedDueDateFilterProps = {
  onChange: ({ value, operator }: AdvancedDueDateFilterValue) => void
  storeValue: AdvancedDueDateFilterValue
  anchorEl: HTMLButtonElement | null
  setAnchorEl: (el: HTMLButtonElement | null) => void
  onUnfocused: () => void
  advancedFilterOptionOperators?: AdvancedFilterOptionOperators
}

export const AdvancedDueDateFilter: React.FC<AdvancedDueDateFilterProps> = ({
  onChange,
  storeValue,
  anchorEl,
  setAnchorEl,
  onUnfocused,
  ...rest
}) => {
  const advancedFilterOptionOperators =
    rest?.advancedFilterOptionOperators ?? advancedDueDateFilterOptionOperators

  const value = storeValue?.value
  const operator =
    storeValue?.operator ?? advancedFilterOptionOperators[0].value

  const isDueInLessThan = operator === 'IS_DUE_IN_LESS_THAN'

  useEffect(() => {
    onChange({ value, operator })
  }, [])

  return (
    <AdvancedFilterPopover
      anchorEl={anchorEl}
      setAnchorEl={setAnchorEl}
      onUnfocused={onUnfocused}
    >
      <Flex flexDirection='column' p={2} pr={1}>
        <TextField
          value={operator}
          select
          size='small'
          label='Select filter operator'
          sx={{
            pr: 1,
            mb: isDueInLessThan && 2,
            minWidth: 200,
          }}
          onChange={(e) =>
            onChange({
              value: null,
              operator: e.target
                .value as AdvancedDueDateFilterValue['operator'],
            })
          }
        >
          {advancedFilterOptionOperators.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        {isDueInLessThan && (
          <Box minWidth={350}>
            <TextField
              value={value}
              onChange={(e) => {
                const value = parseInt(e.target.value)
                onChange({ value, operator })
              }}
              placeholder={localizedStrings.numberOfDays}
              fullWidth
              type='number'
              inputProps={{
                step: 'any',
                'data-test': 'request-numeric-input',
              }}
              onWheel={(e) =>
                e.target instanceof HTMLElement && e.target.blur()
              }
            />
          </Box>
        )}
      </Flex>
    </AdvancedFilterPopover>
  )
}
